import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { SWEEP_ORDER_BASE_PATH } from '../../../../../../../../../features/sweeps/clearing/order/sweep-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/order/_order')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sweep-orders-list',
        label: 'Sweeps',
        to: SWEEP_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
